/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceQueryTagPresence extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceQueryTagPresence");
    }

    getFixupPrototypeFunction() { return ResourceQueryTagPresence.fixupPrototype; }

    static newInstance(model: Partial<ResourceQueryTagPresence>): ResourceQueryTagPresence {
        let obj = Object.assign(new ResourceQueryTagPresence(), model);
        ResourceQueryTagPresence.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceQueryTagPresence>): ResourceQueryTagPresence {
        if (!model) return null;
        return ResourceQueryTagPresence.newInstance(<ResourceQueryTagPresence> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceQueryTagPresence) {
        if (!obj) return;

        models.ResourceQueryTagPresence.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceQueryTagPresence): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceQueryTagPresence.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Matches against resources with or without tags
     */
    has_tags: boolean;

}
